import React from 'react';
import Button from '../Button/Button';
import ButtonGroup, {
  Props as ButtonGroupProps,
} from '../ButtonGroup/ButtonGroup';
import { OnChangeEvent, ToggleButtonGroupEvent } from '../events/EventProvider';
import useEvents from '../events/useEvents';

export type ToggleButtonGroupOption = {
  label: string;
  value: string;
};

export type Props = {
  eventId?: string;
  options: ToggleButtonGroupOption[];
  value?: ToggleButtonGroupOption;
  onChange: (value: ToggleButtonGroupOption) => void;
} & ButtonGroupProps;

const ToggleButtonGroup: React.FC<Props> = ({
  options,
  eventId,
  value,
  onChange,
  ...props
}) => {
  const triggerEvent = useEvents<OnChangeEvent<ToggleButtonGroupEvent>>(
    eventId,
    'ToggleButtonGroup'
  );
  return (
    <ButtonGroup weight="normal" {...props}>
      {options.map((option) => (
        <Button
          // Make font size 12 to accomodate amt selection screen on mobile browsers
          // TODO: Should we make this responsive eventually?
          sx={{ fontSize: '12px' }}
          key={option.value}
          data-testid={`ToggleButtonGroupOption-${option.value}`}
          variant={
            value && value.value === option.value ? undefined : 'outline'
          }
          color={value && value.value === option.value ? undefined : 'neutral'}
          onClick={() => {
            onChange(option);
            triggerEvent({ selected: option });
          }}
        >
          {option.label}
        </Button>
      ))}
    </ButtonGroup>
  );
};

export default ToggleButtonGroup;
